import React, { Component } from 'react';
import { Link } from 'react-router';

import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withTeam from '../../common/withTeam';
import withOnline from '../../common/withOnline';
import withUser from '../../common/withUser';
import withUpdatedRoute from '../../common/withUpdatedRoute';

import Header from '../../components/Header';
import Bugsnag from '../../helpers/bugsnag';
import {
  getRepReports,
  addRepReports,
  getDocuments,
  addDocuments
} from '../../utils/db';
import {
  generateTimedURL,
  getNewRepReports
} from '../../utils/utils';
import {
  getSelectedTeamName,
  storeLastVisitedRoute,
  sortData
} from '../../common/globals';

class Reports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      repReports: [],
      opsReports: [],
      salesReports: [],
      repDocuments: [],
      search: '',
      originalRepReports: [],
      originalRepDocuments: [],
      terrSiteFlag: false,
      terrSite: '',
    };
    this.onlineAlertModal = null;
  }

  componentDidMount() {
    try {
      this.onlineAlertModal = new window.bootstrap.Modal(window.$('#onlineInfoModal'));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getNewReports = async () => {
    try {
      const {
        online, notify, setLoader
      } = this.props;
      if (online) {
        setLoader(true);
        getNewRepReports().then(async (response) => {
          const {
            status,
            message,
            data,
            documents
          } = response;
          if (status) {
            if (response.hasOwnProperty('data')) {
              if (data && data.length > 0) {
                await addRepReports(data);
              }
            }

            if (response.hasOwnProperty('documents')) {
              if (documents && documents.length > 0) {
                await addDocuments(documents);
              }
            }

            await this._getReportData();
            setLoader(false);
          } else {
            notify({ type: 'error', message });
          }
        });
      } else {
        this.onlineAlertModal.show();
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onReport = async (reportName, type) => {
    try {
      const {
        online, notify, setLoader, user
      } = this.props;
      if (online) {
        const generateTimedURLData = {
          team: await getSelectedTeamName(),
          entity_type: type,
          entity_id: reportName,
          token: user.token,
          key: user.userKey
        };
        setLoader(true);
        generateTimedURL(generateTimedURLData).then((response) => {
          setLoader(false);
          const { status, message, data } = response;
          if (status) {
            if (!response.hasOwnProperty('data')) {
              return;
            }
            window.open(data, '_blank', 'fullscreen=yes');
            return false;
          }
          notify({ type: 'error', message });
        });
      } else {
        this.onlineAlertModal.show();
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getReportData = async () => {
    try {
      const repReports = await getRepReports();
      const opsReports = [];
      const salesReports = [];
      repReports.map((report) => {
        if (report.group === 'OPS') {
          opsReports.push(report);
        } else {
          salesReports.push(report);
        }
      });

      const sortedReports = sortData(repReports, 'name');
      repReports && this.setState({
        repReports: sortedReports,
        originalRepReports: repReports,
        opsReports,
        salesReports
      });

      const repDocuments = await getDocuments();
      const data = repDocuments.reduce((r, e) => {
        const group = (e.name !== null) ? e.name[0] : '';
        if (!r[group]) r[group] = { group, children: [e] };
        else r[group].children.push(e);
        return r;
      }, {});

      const result = Object.values(data);
      const sortedDocuments = sortData(result, 'group');

      this.setState({
        repDocuments: sortedDocuments,
        originalRepDocuments: repDocuments
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCopyReport = async (reportData) => {
    try {
      const {
        online, notify, setLoader, user
      } = this.props;
      if (online) {
        const generateTimedURLData = {
          team: await getSelectedTeamName(),
          entity_type: 'reports',
          entity_id: reportData.name,
          token: user.token,
          key: user.userKey
        };
        setLoader(true);
        generateTimedURL(generateTimedURLData).then((response) => {
          setLoader(false);
          const { status, message, data } = response;
          if (status) {
            navigator.clipboard.writeText(data);
            notify({ type: 'success', message: 'URL Copied' });
          } else {
            notify({ type: 'error', message });
          }
        });
      } else {
        this.onlineAlertModal.show();
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSearch = (event) => {
    try {
      let searchTxt = '';
      searchTxt = event.target.value;
      this.setState({ search: searchTxt }, () => {
        this._searchReports();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _searchReports = () => {
    try {
      const { search, originalRepReports, originalRepDocuments } = this.state;
      if (search && search.length > 0) {
        const searchData = search.toUpperCase();
        const newReports = originalRepReports.filter((item) => {
          const match = item.name && item.name.toUpperCase().includes(searchData);
          return match;
        });

        const repDocuments = originalRepDocuments.filter((item) => {
          const match = item.name && item.name.toUpperCase().includes(searchData);
          return match;
        });

        const data = repDocuments.reduce((r, e) => {
          const group = (e.name !== null) ? e.name[0] : '';
          if (!r[group]) r[group] = { group, children: [e] };
          else r[group].children.push(e);
          return r;
        }, {});

        const result = Object.values(data);
        const sortedDocuments = sortData(result, 'group');

        const sortedReports = sortData(newReports, 'name');
        this.setState({
          repReports: sortedReports,
          repDocuments: sortedDocuments
        });
      } else {
        const data = originalRepDocuments.reduce((r, e) => {
          const group = (e.name !== null) ? e.name[0] : '';
          if (!r[group]) r[group] = { group, children: [e] };
          else r[group].children.push(e);
          return r;
        }, {});

        const result = Object.values(data);
        const sortedDocuments = sortData(result, 'group');
        const sortedReports = sortData(originalRepReports, 'name');

        this.setState({
          repReports: sortedReports,
          repDocuments: sortedDocuments,
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      await this._getReportData();
      const {
        online,
        notify,
        setUpdatedRoute,
        user: {
          territories,
          territoryId
        }
      } = this.props;
      if (online) {
        territories.map((item) => {
          if (item.id === territoryId) {
            this.setState({
              terrSiteFlag: (item.terrSite !== 'undefined' && item.terrSite !== null && item.terrSite !== ''),
              terrSite: item.terrSite
            });
          }
        });

        await this._getNewReports();
      } else {
        notify({
          type: 'error',
          message: 'You must have as internet connection. Please check your connection and try again.'
        });
      }
      storeLastVisitedRoute('/reports');
      setUpdatedRoute('/reports');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      search,
      repReports,
      repDocuments,
      terrSiteFlag,
      terrSite
    } = this.state;

    return (
      <section className="list-section sticky-top">
        {
          terrSiteFlag
            ? (
              <Header
                sideMenu
                goBack="/"
                goForward={{
                  title: '<i class="fas fa-globe"></i></a>',
                  url: terrSite,
                  onGoForward: '',
                  showIcon: true,
                  siteFlag: terrSiteFlag
                }}
              />
            ) : (
              <Header
                sideMenu
                goBack="/"
              />
            )
        }

        <section className="filter-section">
          <div className="container">

            <div className="top-block sticky-pref-search">
              <div className="row gx-2">
                <div className="col-12 pt-2 pb-2">
                  <input
                    type="text" className="form-control search-input x-ray-choose-file"
                    placeholder="Search Documents & Reports (title search only)"
                    onChange={(e) => this._onSearch(e)}
                    value={search}
                  />
                </div>
              </div>
            </div>

            <div className="top-block">
              <div
                className="row gx-3 cursor-pointer"
                data-bs-toggle="collapse"
                data-bs-target="#collapse-documents"
                aria-expanded="false"
              >
                <div className="col">
                  <h4>Documents</h4>
                </div>

                <div
                  className="col-auto btn-collapse collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapse-documents"
                  aria-expanded="false"
                >
                  <i className="fas fa-chevron-down" style={{ color: '#eda340' }} />
                </div>

              </div>
            </div>

            <div className="row gx-3 cursor-pointer collapse" id="collapse-documents">
              <div className="col-12">
                {
                  repDocuments.length > 0
                    ? repDocuments.map((item, key) => (
                      <div key={key + 1}>

                        <h4
                          className="bg-cell"
                          style={{
                            backgroundColor: 'rgb(66, 66, 66)',
                            fontSize: '15px',
                            width: '100%',
                            padding: '8px'
                          }}
                        >
                          {item.group}
                        </h4>

                        <div className="row">
                          {
                            item.children.length > 0 && item.children.map((data, index) => (
                              <div className="col-12" key={`${key + 1}-${index + 1}`}>
                                <Link
                                  onClick={() => this._onReport(data.name, 'documents')}
                                >
                                  <p>{data.name}</p>
                                </Link>
                              </div>
                            ))
                          }

                        </div>
                      </div>
                    ))
                    : <p className="text-center">No Document Found.</p>
                }
              </div>
            </div>

            <div className="top-block border-top">
              <div
                className="row gx-3 cursor-pointer"
                data-bs-toggle="collapse"
                data-bs-target="#collapse-reports"
                aria-expanded="true"
              >
                <div className="col">
                  <h4>Reports</h4>
                </div>

                <div
                  className="col-auto btn-collapse"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapse-reports"
                  aria-expanded="true"
                >
                  <i className="fas fa-chevron-down" style={{ color: '#eda340' }} />
                </div>

              </div>
            </div>

            <div className="row gx-3 cursor-pointer collapse show" id="collapse-reports">

              {
                repReports.length > 0
                  ? repReports.map((item, key) => (
                    item.group === 'OPS' && (
                      <div key={key} className="col-12 d-flex mb-3">
                        <Link
                          className="btn btn-theme-alt btn-theme-outline-alt d-block btn-max-width report-title"
                          onClick={() => this._onReport(item.name, 'reports')}
                        >
                          {item.name}
                        </Link>
                        <button
                          className="btn btn-icon copy-icon-color d-none"
                          onClick={
                            () => this._onCopyReport(item)
                          }
                        >
                          <i className="fas fa-copy" />
                        </button>
                      </div>
                    )
                  ))
                  : <p className="text-center">No Reports Available</p>
              }

            </div>

            <div className="top-block border-top" />

            {/* <div
                className="accordion accordion-flush accordion-filter"
                id="accordionFilter">
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingOne">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        Operational Reports
                      </button>
                    </div>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionFilter"
                    >
                      <div className="accordion-body">
                        <div className="row g-4">
                          {
                            opsReports.length > 0
                              ? opsReports.map((item, key) => (
                                item.group === 'OPS' && (
                                  <div key={key} className="col-12 d-flex">
                                    <Link
                                      className="btn btn-theme-alt d-block"
                                      onClick={() => this._onReport(item.name)}
                                    >
                                      {item.name}
                                    </Link>
                                    <button
                                      className="btn btn-icon copy-icon-color"
                                      onClick={
                                        () => this._onCopyReport(item)
                                      }
                                    >
                                      <i className="fas fa-copy" />
                                    </button>
                                  </div>
                                )
                              ))
                              : <div className="text-center mt-5">No Reports Available</div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
          </div>
        </section>
      </section>
    );
  }
}

export default withUser(
  withOnline(
    withTeam(
      withNotify(
        withLoader(
          withUpdatedRoute(
            Reports
          )
        )
      )
    )
  )
);
